import {FC} from 'react'
import {ExtraAction} from '../types'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import clsx from 'clsx'

const MoreActions: FC<{actions: ExtraAction[]}> = ({actions}) => {
  const intl = useIntl()

  return (
    <div className='dropdown-center m-1'>
      <OverlayTrigger
        placement='top'
        overlay={<Tooltip id='tooltip'>{intl.$t({id: 'GENERAL.MORE'})}</Tooltip>}
      >
        <button
          type='button'
          className='btn btn-sm btn-icon btn-light-primary'
          data-bs-toggle='dropdown'
          aria-expanded='false'
        >
          <i className='fa fa-ellipsis-v'></i>
        </button>
      </OverlayTrigger>

      <ul className='dropdown-menu rounded'>
        {actions.map((action, idx) => {
          const labelHasTranslation = action.label ? !!intl.messages[action.label] : false
          const labelTranslation = labelHasTranslation ? intl.$t({id: action.label}) : action.label

          const color = action.color?.replace('light-', '')?.replace('outline-', '') || 'primary'

          if (action.type === 'button') {
            return (
              <li className='px-2' key={idx}>
                <span
                  className={clsx(
                    'dropdown-item rounded fw-semibold cursor-pointer px-3 py-2',
                    `bg-hover-light-${color}`,
                    `text-hover-${color}`
                  )}
                  onClick={() => action.onClick()}
                >
                  {labelTranslation}
                </span>
              </li>
            )
          } else if (action.type === 'link') {
            return (
              <li className='px-2' key={idx}>
                <Link
                  to={action.to}
                  className={clsx(
                    'dropdown-item rounded fw-semibold px-3 py-2',
                    `bg-hover-light-${color}`,
                    `text-hover-${color}`
                  )}
                >
                  {labelTranslation}
                </Link>
              </li>
            )
          }
          return null
        })}
      </ul>
    </div>
  )
}

export default MoreActions
